import './ReceiptIcon.css';

// File-type glyphs for an attached receipt. Hand-drawn rather than lucide
// because the PDF one carries the letters "PDF" inside the page outline —
// lucide's FileText is generic, and at 18px the distinction between a scanned
// image and a PDF is the whole point of the icon.
//
// These lived in ExpensesPage; the travel modal is the second caller, which is
// the point where a private copy becomes two copies that drift.

function PdfIcon(): JSX.Element {
  return (
    <svg className="receipt-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        fill="currentColor"
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
      />
      <text
        x="12"
        y="17"
        textAnchor="middle"
        fill="currentColor"
        fontSize="5.5"
        fontWeight="700"
        fontFamily="var(--font-sans), system-ui, sans-serif"
      >
        PDF
      </text>
    </svg>
  );
}

function ImageIcon(): JSX.Element {
  return (
    <svg className="receipt-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        fill="currentColor"
        d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 16H5V5h14v14zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z"
      />
    </svg>
  );
}

/** Glyph for a receipt, chosen by mime type. Anything that isn't a PDF is
 *  drawn as an image — receipts are only ever one or the other. */
export function ReceiptIcon({ mimeType }: { mimeType: string }): JSX.Element {
  return mimeType === 'application/pdf' ? <PdfIcon /> : <ImageIcon />;
}
